
// import { useState, useEffect } from 'react';
// import * as React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getStates } from "./../../../redux/actions/States.action";
// import { FaDownload } from "react-icons/fa";

// function EditableReportTable({ datas, editedValues, headers, handleInputChange, edithandleClickOpenalert, handleCancelClick, handleEditClick, handledeleteClickOpenalert, editableRow, handledeleteSubmit, tableName, tableNamedate }) {
//     const [data, setData] = useState(datas);
//     const [selectAll, setSelectAll] = useState(false);
//     const [checkedItemCount, setCheckedItemCount] = useState(0);
//     const [statedata, setstate] = useState([]);
//     const dispatch = useDispatch();
//     const checkstate = "state";
//     const daysoptions = [
//         { key: 'sunday', value: 'Sunday' },
//         { key: 'monday', value: 'Monday' },
//         { key: 'tuesday', value: 'Tuesday' },
//         { key: 'wednesday', value: 'Wednesday' },
//         { key: 'thursday', value: 'Thursday' },
//         { key: 'friday', value: 'Friday' },
//         { key: 'saturday', value: 'saturday ' },
//     ];
//     const regularHeaders = headers.filter(header => header.key !== 'AuthorisedSignatory' && header.key !== 'AuthDesignation');
//     const specialHeaders = headers.filter(header => header.key === 'AuthorisedSignatory' || header.key === 'AuthDesignation');
    // const fetchState = async () => {
    //     try {
    //         const response = await dispatch(getStates());
    //         setstate(response.data.states);
    //     } catch (err) {
    //         console.error("Failed to fetch clients:", err);
    //     }
    // }
    // useEffect(() => {

    //     fetchState();
    // }, [dispatch]);

//     const [order, setorder] = useState('ASC');
//     useEffect(() => {
//         setData(datas);
//     }, [datas]);
//     const sorting = (col) => {
//         if (order === 'ASC') {
//             const sorted = [...data].sort((a, b) =>
//                 typeof a[col] === 'number' && typeof b[col] === 'number'
//                     ? a[col] - b[col]
//                     : a[col].toLowerCase() > b[col].toLowerCase()
//                         ? 1
//                         : -1
//             );
//             setData(sorted);
//             setorder('DSC');
//         }
//         if (order === 'DSC') {
//             const sorted = [...data].sort((a, b) =>
//                 typeof a[col] === 'number' && typeof b[col] === 'number'
//                     ? b[col] - a[col]
//                     : a[col].toLowerCase() < b[col].toLowerCase()
//                         ? 1
//                         : -1
//             );
//             setData(sorted);
//             setorder('ASC');
//         }
//     };
//     useEffect(() => {
//         if (data) {
//             var allChecked = data.every(item => item.checked);
//         }
//         setSelectAll(allChecked);
//     }, [data]);
//     const handleCheckboxChange = (id) => {
//         const newData = data.map(item => {
//             if (item.Client_id === id) {
//                 return { ...item, checked: !item.checked };
//             }
//             return item;
//         });
//         setData(newData);
//         setCheckedItemCount(getCheckedItemCount(newData));
//     };
//     const handleSelectAllChange = () => {
//         const newSelectAll = !selectAll;
//         const newData = data.map(item => ({ ...item, checked: newSelectAll }));
//         setData(newData);
//         setSelectAll(newSelectAll);
//         setCheckedItemCount(getCheckedItemCount(newData));
//     };
//     const getCheckedItemCount = (data) => {
//         return data.filter(item => item.checked).length;
//     };
//     const calculateWidth = (text) => {
//         const charWidth = 11;
//         // alert(text);
//         if (text == "Address") {
//             return `250px`;
//         } else {
//             return `${text.length * charWidth}px`;
//         }
//     };
//     return (

//         <form onSubmit={handledeleteSubmit} >
//             <div className="card-header p-0 pe-3 ps-1">
//                 <div className="col-md-12">
//                     <div className="row justify-content-between">
//                         <div className="col-md-3">
//                             <h6 className='headerSm pt-1'>{tableNamedate}  <span className='spantotal-display'>(Total Entries :{data ? data.length : 0})</span></h6>
//                         </div>
//                         <div className="col-md-4">

//                         </div>
//                         <div className="col-md-5">
//                             <div className="row float-end">
//                                 {/* <p className='pt-1 m-0 client-2nd-header-size'></p> */}
//                                 <p className='col-md-11 pt-1 client-2nd-header-size m-0 pt-2'> <span className=''>Selected Entries: {checkedItemCount} </span> </p>
//                                 {/* Total Entries: {data ? data.length : 0} */}
//                                 <div className="dropdown col-md-1 p-0 pb-2">
//                                     <button className=" p-0 pt-2 w-0 border-0 btn-transparent " type="button" data-bs-toggle="dropdown" aria-expanded="false">
//                                         <i className="bi bi-three-dots-vertical mb-1"></i>
//                                         </button>
//                                     <ul className="dropdown-menu btn-z-indexer">
//                                         <li><button className="dropdown-item" type='submit' value="deleteData">Delete Selected</button></li>
//                                         <li><button className="dropdown-item " type='submit' value="downloadData">Download Selected</button></li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="table-responsive bg-white border-1 scrollable-tbody tablefontsize">
//                 <table className='client-table table table-bordered' id='dataTable'>
//                     <thead className='client-table-header sticky-top bg-light'>
//                         <tr>
//                             <th className="text-center bg-light"><input type="checkbox" checked={selectAll} onChange={() => handleSelectAllChange()} /></th>
//                             <th className='text-center sortable slnowidth bg-light' >
//                                 <div className="col-md-12">
//                                     <div className="row">
//                                         <div className="col-md-12 text-center ">SL No</div>
//                                         {/* <div className="col-md-3 sort-icon">
//                                             <i className="bi bi-sort-down"></i>
//                                         </div> */}
//                                     </div>
//                                 </div>
//                             </th>
//                             {regularHeaders.map((header, index) => (
//                                 <th key={index} className='text-center sortable bg-light' onClick={() => sorting(header.key)} style={{ minWidth: calculateWidth(header.label) }} >
//                                     <div className="col-md-12">
//                                         <div className="row px-2">
//                                             <div className="col-md-10 p-0">{header.label}</div>
//                                             <div className="col-md-2 sort-icon p-0">
//                                                 <i className="bi bi-sort-down"></i>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>
//                             ))}
//                             {specialHeaders.map((header, index) => (
//                                 <th key={index} className='text-center sortable bg-light' onClick={() => sorting(header.key)} style={{ minWidth: calculateWidth(header.label) }} >
//                                     <div className="col-md-12">
//                                         <div className="row px-2">
//                                             <div className="col-md-10 p-0">{header.label}</div>
//                                             <div className="col-md-2 sort-icon p-0">
//                                                 <i className="bi bi-sort-down"></i>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>
//                             ))}
                            // {tableName === "ClientTable" ? (
                            //     <th className='text-center' style={{ minWidth: "100px" }} >Total Units</th>
                            // ) : (
                            //     <></>
                            // )}
//                             <th className='text-center p-2 bg-light'>
//                                 Action
//                             </th>

                            // {tableName === "ClientTable" ? (
                            //     <th className='text-center' style={{ minWidth: "100px" }} >Add Units</th>
                            // ) : (
                            //     <></>
                            // )}
//                         </tr>
//                     </thead>
//                     <tbody className='bg-white client-end sticky-col' >
//                         {data ? (

//                             <>
//                                 {data.map((item, index) => (
//                                     <tr key={item.id} className={item.checked ? 'checked-row' : ''}>
//                                         <td className=" text-center"><input type="checkbox" checked={item.checked} onChange={() => handleCheckboxChange(item.id)} name="selectedClientId" value={item.id} /></td>
//                                         <td className=" text-center">{index + 1}</td>
//                                         {regularHeaders.map((header) => (
//                                             <td className="text-center" key={header.key}>
//                                                 {editableRow === item.id ? (
//                                                     header.key === "State" ? (
//                                                         <select>
//                                                             <option value="">--Select--</option>
//                                                             {statedata ? (
//                                                                 statedata.map((item) => (
//                                                                     <option key={item.state_name} value={item.state_name} >
//                                                                         {item.state_name}
//                                                                     </option>
//                                                                 ))
//                                                             ) : (
//                                                                 <option value="">No states available</option>
//                                                             )}
//                                                         </select>
//                                                     ) : (
//                                                         <input
//                                                             type={header.input}
//                                                             value={editedValues[header.key]}
//                                                             name={header.key}
//                                                             onChange={handleInputChange}
//                                                             readOnly={header.readOnly}
//                                                         />
//                                                     )
//                                                 ) : (
//                                                     header.input === "mail" ? (
//                                                         <a href={`mailto:${item[header.key]}`}>{item[header.key]}</a>
//                                                     ) :(
//                                                         <span className='tdDataMaxheight'>
//                                                           {header.input === "date" && item[header.key]
//                                                             ? new Date(item[header.key]).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) // Converts to 'DD/MM/YYYY'
//                                                             : item[header.key]}
//                                                         </span>
//                                                       )
//                                                 )}
//                                             </td>
//                                         ))}
//                                         {specialHeaders.map((header) => (
//                                             <td className="text-center" key={header.key}>
//                                                 {editableRow === item.id ? (
//                                                     <input
//                                                         type='file'
//                                                         name={header.key}
//                                                         onChange={handleInputChange}
//                                                     />
//                                                 ) : <>{item[header.key] ? <a className='tdDataMaxheight'><FaDownload /></a> : <></>}</>}
//                                             </td>
//                                         ))}
//                                         {tableName === "ClientTable" ? (
//                                             <td className="text-center">
//                                                 <a href={`unit-master/${item.client_id}`}>{item.TotalUnits}</a>
//                                             </td>
//                                         ) : (
//                                             <></>
//                                         )}

//                                         <td className='text-center'>
//                                             {editableRow === item.id ? (
//                                                 <div className="d-flex justify-content-between">
//                                                     <span onClick={edithandleClickOpenalert} className='btn p-0'><i className="bi bi-save-fill text-success auction-btn"></i></span>
//                                                     <span onClick={handleCancelClick} className='btn p-0'><i className="bi bi-x-circle text-info auction-btn"></i></span>
//                                                 </div>
//                                             ) : (
//                                                 <div className="d-flex justify-content-between">
//                                                     <span onClick={() => handleEditClick(item.id)} className='btn p-0'><i className="bi bi-pencil-square text-info auction-btn"></i></span>
//                                                     <span onClick={() => handledeleteClickOpenalert(item.id)} className='btn p-0'><i className="bi bi-trash3-fill text-danger auction-btn"></i></span>
//                                                 </div>
//                                             )}
//                                         </td>
                                        // {tableName === "ClientTable" ? (
                                        //     <td className='text-center'><a href={`unit-master/${item.client_id}`}><i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i> </a></td>
                                        // ) : (
                                        //     <></>
                                        // )}
//                                     </tr>
//                                 ))}
//                             </>
//                         ) : (
//                             <tr>
//                                 No data found
//                             </tr>
//                         )}

//                     </tbody>
//                 </table>
//             </div>
//         </form>
//     );
// }

// export default EditableReportTable;




import React, { useState, useEffect, forwardRef } from 'react'
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import './clientform.css'
import { downloadAllSelectedIDsRecords } from './../../../../services/global_redux/globale_actions/Download.action';
// import image from "./../../../templates/newtest.png"

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function Reusabletable({ data, header, setFile, handleFileUpload, submitdelete, editableRow, setEditableRow, handleSaveClick, setEditedValues, editedValues, handledeleteClickOpenalert, title, filestemp, setLoading, showSnackbar, date,handleFormToggleSingleDataEntry ,isFormOpen}) {
    const [checkedItems, setCheckedItems] = useState({});
    const [checkedItemCount, setCheckedItemCount] = useState(0);
    const [deletesingleID, setdeletesingleID] = useState({});
    const [uploadFormVisible, setuploadVisible] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [openeditalert, setOpeneditalert] = useState(false);
    const [opendeletealert, setopendeletealert] = useState(false);
    const [opendeletemultialert, setopendeletemultialert] = useState(false);
    const [selectedClient, setSelectedClient] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const current_month = date;
    const titleName = title;
    const dispatch = useDispatch();

    const handleSearchClick = (e) => {
        e.preventDefault();
        const value = $('#searchInput').val().toLowerCase();
        $('#dataTable tbody tr').each(function () {
            const rowText = $(this).text().toLowerCase();
            const isVisible = rowText.includes(value);
            $(this).toggle(isVisible);
        });
    };
    // const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    // };
    const handleFileChange = (e) => {
        // const { name, files } = e.target;
        // const file = files[0];

        // if (file) {
        //   setEditedValues(prev => ({
        //     ...prev,
        //     [name]: file,
        //     [`${name}_preview`]: URL.createObjectURL(file)
        //   }));
        // }
        setFile(e.target.files[0]);
      };

    const handleFileUploaddata = (e) => {
        handleFileUpload()
        setuploadVisible(!uploadFormVisible)
    };
    const updateCheckAllState = () => {
        const allChecked = data.length > 0 && data.every(item => checkedItems[item.id]);
        setIsAllChecked(allChecked);
    };

    useEffect(() => {
        updateCheckAllState();
    }, [checkedItems]);
    useEffect(() => {
        const count = Object.values(checkedItems).filter(Boolean).length;
        setCheckedItemCount(count);
    }, [checkedItems]);
    const handleCheckChange = (id) => {
        setCheckedItems(prevCheckedItems => ({
            ...prevCheckedItems,
            [id]: !prevCheckedItems[id]
        }));
    };

    const handleCheckAll = () => {
        const newCheckedItems = { ...checkedItems };
        const visibleRows = $('#dataTable tbody tr:visible');

        const allVisibleChecked = visibleRows.toArray().every(row => {
            const id = $(row).data('id');
            return checkedItems[id];
        });

        const shouldCheck = !allVisibleChecked;

        visibleRows.each(function () {
            const id = $(this).data('id');
            newCheckedItems[id] = shouldCheck;
        });

        setCheckedItems(newCheckedItems);
    };
    const selectedDelete = (e) => {
        e.preventDefault();
        const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
        setopendeletemultialert(false)
        const selectedid = { ids: selectedIds };
        submitdelete(selectedid);
    };
    const handleCancelClick = () => {
        setEditableRow(null);
        setEditedValues({});
    };
    const handleEditClick = (id) => {
        const item = data.find(d => d.id === id);
        setEditableRow(id);
        setEditedValues({ ...item });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedValues({
            ...editedValues,
            [name]: value,
        });
    };
    const handleCloseeditalert = () => {
        setOpeneditalert(false);
        setEditableRow(null);
        setEditedValues({});
    };
    const handleSavealert = () => {
        setOpeneditalert(true)
    }
    const handleSaveClickconfirmed = () => {
        setOpeneditalert(false)
        handleSaveClick()
    }
    const handledeletealert = (id) => {
        setopendeletealert(true)
        setdeletesingleID(id)
    }
    const handledeleteClickconfirmed = () => {
        setopendeletealert(false)
        handledeleteClickOpenalert(deletesingleID)
    }
    const handledeleteClosealert = () => {
        setopendeletealert(false)
    }
    const handledeletemultialert = (e) => {
        e.preventDefault()
        const buttonClicked = e.nativeEvent.submitter.value;
        if (checkedItemCount == 0) {
            showSnackbar("select the ID", 'warning');
        } else {

            if (buttonClicked === 'deleteData') {
                setopendeletemultialert(true)
            } else if (buttonClicked === "downloadData") {

                const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
                const client_id = sessionStorage.getItem('selectedClient')
                const data = {
                    client_id: client_id,
                    current_month: current_month,
                    titleName: titleName,
                    selectedIds: selectedIds
                }
                submitdownload(data);
            }

        }
    }
    const submitdownload = async (data) => {
        setLoading(true);
        try {
            const response = await dispatch(downloadAllSelectedIDsRecords(data));
            if (response.success == true) {
                showSnackbar("downloadded", 'success');
                setLoading(false);
            } else {
                showSnackbar(response.error, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    }
    const handledeletemultiClosealert = () => {
        setopendeletemultialert(false)
        setCheckedItems({})
    }
    const calculateWidth = (text) => {
        const charWidth = 11;
        return `${text.length * charWidth}px`;
    };
    const uniqueClients = Array.isArray(data)
        ? data.reduce((unique, client) => {
            if (!unique.some(item => item.unit_id === client.unit_id)) {
                unique.push(client);
            }
            return unique;
        }, [])
        : [];

    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };
    const filteredData = selectedClient
        ? data.filter(item => item.unit_id === selectedClient)
        : data;
    function formatDate(dateString) {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            // Handle the case where dateString is invalid
            return "Invalid Date";
        }

        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Intl.DateTimeFormat('en-GB', options).format(date).replace(/ /g, '-');
    }
    function formatDateForInput(dateString) {
        // Try to create a Date object from the provided date string
        const date = new Date(dateString);

        // Check if the date is invalid
        if (isNaN(date.getTime())) {
            // Handle the case where the dateString is invalid
            console.error("Invalid date string:", dateString);
            return null; // or handle the error as needed
        }

        // Format the date as YYYY-MM-DD
        return date.toISOString().split('T')[0];
    }

    const formatGender = (value) => {
        switch (value.toLowerCase()) {
            case 'm':
                return 'Male';
            case 'f':
                return 'Female';
            case 't':
                return 'Transgender';
            default:
                return 'Unknown';
        }
    };

    const sortedData = Array.isArray(filteredData) && filteredData.length > 0
    ? [...filteredData].sort((a, b) => {
        if (!sortConfig?.key) return 0;
        const valueA = a[sortConfig.key] || "";
        const valueB = b[sortConfig.key] || "";

        if (typeof valueA === "number" && typeof valueB === "number") {
            return sortConfig.direction === "asc" ? valueA - valueB : valueB - valueA;
        } else {
            return sortConfig.direction === "asc"
                ? valueA.toString().localeCompare(valueB.toString())
                : valueB.toString().localeCompare(valueA.toString());
        }
    })
    : [];


    // Handle sorting click
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };

    // Render sort icon
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return "";
        return sortConfig.direction === "asc" ? "▲" : "▼";
    };

    return (
        <div className="col-md-12 py-3">
            <div className="card">
                <div className="card-header card-header-color py-0">
                    <div className="col-md-12">
                        <div className="row client-form-header  d-flex">
                            <div className="col-md-6 pt-2">
                                <h6 className='text-dark'>{title}</h6>
                            </div>
                            <div className="col-md-6">
                                {title == "Org Details" ?(<>
                                    <a href="/dashboard" className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>
                                    </>):(
                                    <>
                                    <a href="/configuration/org-details" className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>
                                    </>)}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row ps-4">
                                <div className="col-md-9 pt-3  ">
                                <button
                                                        className="btn btn-info text-white me-3"
                                                        onClick={() => handleFormToggleSingleDataEntry('AddSingleclient')}
                                                        disabled={isFormOpen}
                                                    >
                                                        <b>Add Single</b>
                                                    </button>
                                                    <button
                                                className="btn btn-info text-white me-3 col-md-3"
                                                onClick={() => setuploadVisible(!uploadFormVisible)}
                                            >
                                                <b>Import {title}</b>
                                            </button>
                                    {/* {setFile == "single_input" ?(
                                        <div className="row justify-content-between">
                                            <button
                                                className="btn btn-info text-white me-3 col-md-3"
                                                onClick={() => filestemp()}
                                            >
                                                <b>Add {title}</b>
                                            </button>
                                        </div>

                                    ):(
                                        <div className="row justify-content-between">
                                            <button
                                                className="btn btn-info text-white me-3 col-md-3"
                                                onClick={() => setuploadVisible(!uploadFormVisible)}
                                            >
                                                <b>Import {title}</b>
                                            </button>
                                        </div>
                                    )} */}
                                </div>
                                <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-md-12 float-end">
                                            <form action="">
                                                <div className=" d-flex search-div float-end m-0">
                                                    <input
                                                        type="text"
                                                        placeholder="Search..."
                                                        id="searchInput"
                                                        className='bg-light headerXsm'
                                                    />
                                                    <button onClick={handleSearchClick} className='search-submit bg-light'><i className="bi bi-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                {uploadFormVisible && (
                                    <div className='col-md-5'>
                                        <div className="row">
                                            <div className="card p-0 m-3">
                                                <div className="card-header pe-0 ">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-10">
                                                                <h6>Import {title} file</h6>
                                                            </div>
                                                            <div className="col-md-2 float-end cursor-pointer pe-4">
                                                                <i className="bi bi-x float-end p-0" onClick={() => setuploadVisible(!uploadFormVisible)}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <label for="formFile" className="form-label"><b>Import File</b></label>
                                                        <a href={filestemp} download={title} className='float-end'>
                                                            template
                                                        </a>
                                                        <input className="form-control" type="file" id="formFile" onChange={handleFileChange} accept=".xls,.xlsx" />
                                                    </div>
                                                    <div className='float-end'>
                                                        <button className='btn btn-success btn-sm' onClick={handleFileUploaddata} type='submit'>Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )}
                            </div>
                            <div className="card mt-0">
                                <form onSubmit={handledeletemultialert}>
                                    <div className="card-header p-0 pe-3 ps-1 mx-3 ">
                                        <div className="col-md-12">
                                            <div className="row justify-content-between">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <p className='pt-1 m-0 client-2nd-header-size col-md-3'>Selected Entries: {checkedItemCount}</p>

                                                        <div className='col-md-4'>
                                                            {title != "Holiday" ?(<></>):(
                                                                <select class="form-select py-0 selunitoption mt-1" aria-label="Default select example" onChange={handleClientChange}>
                                                                    <option value="" className='selunitoption text-dark'>
                                                                        All unit
                                                                    </option>
                                                                    {uniqueClients.map((client, index) => (
                                                                        <option key={index} value={client.unit_id} className='selunitoption text-dark'>
                                                                            {client.unit_id}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                )}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row float-end">
                                                        <p className='col-md-11 pt-1 client-2nd-header-size m-0'>Total Entries: {data ? data.length : 0}</p>
                                                        <div className="dropdown col-md-1 p-0 bg-transparent">
                                                            <button className=" p-0 pt-2 w-0 border-0 btn-transparent " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="bi bi-three-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu btn-z-indexer">
                                                                {submitdelete != null && (
                                                                <li><button className="dropdown-item " type='submit' value="deleteData">Delete Selected</button></li>)}
                                                                <li><button className="dropdown-item " type='submit' value="downloadData">Download Selected</button></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body m-0 p-0">
                                        <div className="table-responsive bg-white border-1 mx-3 mb-4 tablefontsize">
                                            {header.length !== 0 ? (
                                                <table className='table client-table table-bordered' id='dataTable'>
                                                    {/* <thead className='sticky-top sticky-col-form'>
                                                        <tr>
                                                            <th className='card-header-color  text-dark'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} name="" id="" /></th>
                                                            <th className='slnowidth  card-header-color  text-dark'><span>SL NO</span></th> */}
                                                            {/* {header.map(headerItem => (
                                                                <th key={headerItem.key} style={{ minWidth: calculateWidth(headerItem.value) }} className='  card-header-color  text-dark'>{headerItem.value} {getSortIcon(headerItem.key)}</th>
                                                            ))} */}
{/*
                                                            {header.map((headerItem) => (
                                                                    <th
                                                                        key={headerItem.key}
                                                                        onClick={() => handleSort(headerItem.key)}
                                                                        style={{ minWidth: calculateWidth(headerItem.value), cursor: "pointer" }}
                                                                        className="card-header-color text-dark"
                                                                    >
                                                                        {headerItem.value} {getSortIcon(headerItem.key)}
                                                                    </th>
                                                            ))}
                                                            <tr>
                                                            {title === "Client Master" ? (
                                                                <th className='text-center' style={{ minWidth: "100px" }} >Total Units</th>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <th className='card-header-color  text-dark'>Action</th>

                                                            {title === "Client Master" ? (
                                                                <th className='text-center' style={{ minWidth: "100px" }} >Add Units</th>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            </tr>
                                                        </tr>
                                                    </thead> */}

                                                    {/* <tbody className='sticky-col-form'>
                                                        {sortedData.length > 0 ? (
                                                            <>
                                                                {sortedData.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td className='tabletdheight'><input type="checkbox" name="" id="" checked={checkedItems[item.id] || false} onChange={() => handleCheckChange(item.id)} /></td>
                                                                        <td className='tabletdheight'>{index + 1}</td>
                                                                        {header.map(headerItem => (
                                                                            <td key={headerItem.key} className='tabletdheight'>
                                                                                {headerItem.input == "date" ? (
                                                                                    <>
                                                                                        {editableRow === item.id ? (
                                                                                            <input
                                                                                                type={headerItem.input}
                                                                                                value={formatDateForInput(editedValues[headerItem.key])}
                                                                                                name={headerItem.key}
                                                                                                onChange={handleInputChange}
                                                                                                readOnly={headerItem.readOnly}
                                                                                            />
                                                                                        ) : (
                                                                                            <span className='tabletdheight'>{formatDate(item[headerItem.key])}</span>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {editableRow === 'gender' ? (
                                                                                            <>
                                                                                                {editableRow === item.id ? (
                                                                                                    <select name={headerItem.key} id={headerItem.key} onChange={handleInputChange}>
                                                                                                        <option value="" disabled>--select--</option>
                                                                                                        <option value="M" selected={editedValues[headerItem.key] === "M" ? true : false}>
                                                                                                            Male
                                                                                                        </option>
                                                                                                        <option value="F" selected={editedValues[headerItem.key] === "F" ? true : false}>
                                                                                                            Female
                                                                                                        </option>
                                                                                                        <option value="T" selected={editedValues[headerItem.key] === "T" ? true : false}>
                                                                                                            Transgender
                                                                                                        </option>
                                                                                                    </select>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <span className='tabletdheight'>{formatGender(item[headerItem.key])}</span>
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                {editableRow === item.id ? (
                                                                                                    <input
                                                                                                        type={headerItem.input}
                                                                                                        value={editedValues[headerItem.key]}
                                                                                                        name={headerItem.key}
                                                                                                        onChange={handleInputChange}
                                                                                                        readOnly={headerItem.readOnly}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <span className='tabletdheight'>{headerItem.key === 'gender' ? formatGender(item[headerItem.key]) : item[headerItem.key]}</span>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}

                                                                            </td>
                                                                        ))}
                                                                        <td className='text-center tabletdheight'>
                                                                            {editableRow === item.id ? (
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span onClick={handleSavealert} className='btn p-0'><i className="bi bi-save-fill text-success auction-btn"></i></span>
                                                                                    <span onClick={handleCancelClick} className='btn p-0'><i className="bi bi-x-circle text-info auction-btn"></i></span>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span onClick={() => handleEditClick(item.id)} className='btn p-0'><i className="bi bi-pencil-square text-info auction-btn"></i></span>
                                                                                    <span onClick={() => handledeletealert(item.id)} className='btn p-0'><i className="bi bi-trash3-fill text-danger auction-btn"></i></span>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={header.length} className="text-center fs-3 fw-bold text-muted">
                                                                    No Record Available
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody> */}
                                                    <thead className='sticky-top sticky-col-form'>
                                                        <tr>
                                                            <th className='card-header-color  text-dark'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} name="" id="" /></th>
                                                            <th className='slnowidth  card-header-color  text-dark'>Sl No.</th>
                                                            {header.map(headerItem => (
                                                                <th
                                                                    key={headerItem.key}
                                                                    onClick={() => handleSort(headerItem.key)}
                                                                    style={{ minWidth: calculateWidth(headerItem.value), cursor: "pointer" }}
                                                                    className="card-header-color text-dark"
                                                                >
                                                                    {headerItem.value} {getSortIcon(headerItem.key)}
                                                                </th>
                                                            ))}

                                                            {title === "Org Details" && (
                                                                <th className='card-header-color  text-dark'>Total Units</th>
                                                            )}

                                                            <th className='card-header-color text-dark text-center'>Actions</th>

                                                            {title === "Org Details" && (
                                                                <th className='card-header-color  text-dark'>Add Units</th>
                                                            )}

                                                        </tr>
                                                    </thead>

                                                    {/* <tbody className='sticky-col-form'>
                                                        {sortedData.length > 0 ? (
                                                            sortedData.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td className='tabletdheight'>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={checkedItems[item.id] || false}
                                                                            onChange={() => handleCheckChange(item.id)}
                                                                        />
                                                                    </td>
                                                                    <td className='tabletdheight'>{index + 1}</td>

                                                                    {header.map(headerItem => (
                                                                        <td key={headerItem.key} className='tabletdheight'>
                                                                            {headerItem.input === "date" ? (
                                                                                editableRow === item.id ? (
                                                                                    <input
                                                                                        type="date"
                                                                                        value={formatDateForInput(editedValues[headerItem.key])}
                                                                                        name={headerItem.key}
                                                                                        onChange={handleInputChange}
                                                                                        readOnly={headerItem.readOnly}
                                                                                    />
                                                                                ) : (
                                                                                    <span className='tabletdheight'>{formatDate(item[headerItem.key])}</span>
                                                                                )
                                                                            ) : headerItem.key === "gender" ? (
                                                                                editableRow === item.id ? (
                                                                                    <select
                                                                                        name={headerItem.key}
                                                                                        value={editedValues[headerItem.key]}
                                                                                        onChange={handleInputChange}
                                                                                    >
                                                                                        <option value="" disabled>--select--</option>
                                                                                        <option value="M">Male</option>
                                                                                        <option value="F">Female</option>
                                                                                        <option value="T">Transgender</option>
                                                                                    </select>
                                                                                ) : (
                                                                                    <span className='tabletdheight'>{formatGender(item[headerItem.key])}</span>
                                                                                )
                                                                            ) : (
                                                                                editableRow === item.id ? (
                                                                                    <input
                                                                                        type={headerItem.input}
                                                                                        value={editedValues[headerItem.key]}
                                                                                        name={headerItem.key}
                                                                                        onChange={handleInputChange}
                                                                                        readOnly={headerItem.readOnly}
                                                                                    />
                                                                                ) : (
                                                                                    <span className='tabletdheight'>{item[headerItem.key]}</span>
                                                                                )
                                                                            )}
                                                                        </td>
                                                                    ))}

                                                                    {title === "Client Master" && (
                                                                        <td className='tabletdheight text-center'>
                                                                            {item.total_units || 0}
                                                                        </td>
                                                                    )}

                                                                    <td className='text-center tabletdheight'>
                                                                        {editableRow === item.id ? (
                                                                            <div className="d-flex justify-content-between">
                                                                                <span onClick={handleSavealert} className='btn p-0'>
                                                                                    <i className="bi bi-save-fill text-success auction-btn"></i>
                                                                                </span>
                                                                                <span onClick={handleCancelClick} className='btn p-0'>
                                                                                    <i className="bi bi-x-circle text-info auction-btn"></i>
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex justify-content-between">
                                                                                <span onClick={() => handleEditClick(item.id)} className='btn p-0'>
                                                                                    <i className="bi bi-pencil-square text-info auction-btn"></i>
                                                                                </span>
                                                                                <span onClick={() => handledeletealert(item.id)} className='btn p-0'>
                                                                                    <i className="bi bi-trash3-fill text-danger auction-btn"></i>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </td> */}

                                                                    {/* {title === "Client Master" && (
                                                                        <td className='tabletdheight text-center'>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                href={`unit-master/${item.client_id}`}
                                                                            >
                                                                                Add
                                                                            </button> */}
                                                                            {/* <td className='text-center'><a href={`unit-master/${item.client_id}`}><i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i> </a></td> */}
                                                                        {/* </td>
                                                                    )} */}
                                                                    {/* {title === "Client Master" && (
                                                                        <td className='text-center'>
                                                                            <a href={`unit-master/${item.client_id}`}>
                                                                                <i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i>
                                                                            </a>
                                                                        </td>
                                                                    )}

                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={header.length + 5} className="text-center">No records found.</td>
                                                            </tr>
                                                        )}
                                                    </tbody> */}
<tbody className='sticky-col-form'>
  {sortedData.length > 0 ? (
    sortedData.map((item, index) => (
      <tr key={index} data-id={item.id}>
        <td className='tabletdheight'>
          <input
            type="checkbox"
            checked={checkedItems[item.id] || false}
            onChange={() => handleCheckChange(item.id)}
          />
        </td>
        <td className='tabletdheight'>{index + 1}</td>

        {header.map(headerItem => (
          <td key={headerItem.key} className='tabletdheight'>
            {headerItem.input === "date" ? (
              editableRow === item.id ? (
                <input
                  type="date"
                  value={formatDateForInput(editedValues[headerItem.key])}
                  name={headerItem.key}
                  onChange={handleInputChange}
                  readOnly={headerItem.readOnly}
                />
              ) : (
                <span className='tabletdheight'>{formatDate(item[headerItem.key])}</span>
              )
            ) : headerItem.key === "gender" ? (
              editableRow === item.id ? (
                <select
                  name={headerItem.key}
                  value={editedValues[headerItem.key]}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>--select--</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="T">Transgender</option>
                </select>
              ) : (
                <span className='tabletdheight'>{formatGender(item[headerItem.key])}</span>
              )
            ) : headerItem.input === "file" ? (
              editableRow === item.id ? (
                <>
                  <input
                    type="file"
                    name={headerItem.key}
                    onChange={handleFileChange}
                    readOnly={headerItem.readOnly}
                  />
                  {editedValues[`${headerItem.key}_preview`] && (
                    <img
                      src={editedValues[`${headerItem.key}_preview`]}
                      alt="Preview"
                      style={{
                        width: '60px',
                        height: '60px',
                        marginTop: '5px',
                        borderRadius: '4px',
                        objectFit: 'cover'
                      }}
                    />
                  )}
                </>
              ) : (
                item[headerItem.key] ? (
                  <img
                    // src={`http://localhost:5000/${item[headerItem.key]}`}
                    src ={headerItem.key}
                    alt="Uploaded Image"
                    style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '4px',
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <span>No image</span>
                )
              )
            ) : (
              editableRow === item.id ? (
                <input
                  type={headerItem.input}
                  value={editedValues[headerItem.key] || ""}
                  name={headerItem.key}
                  onChange={handleInputChange}
                  readOnly={headerItem.readOnly}
                />
              ) : (
                <span className='tabletdheight'>{item[headerItem.key]}</span>
              )
            )}
          </td>
        ))}

        {title === "Org Details" && (
          <td className='tabletdheight text-center'>
            {item.total_units || 0}
          </td>
        )}

        <td className='text-center tabletdheight'>
          {editableRow === item.id ? (
            <div className="d-flex justify-content-between">
              <span onClick={handleSavealert} className='btn p-0'>
                <i className="bi bi-floppy2-fill text-success auction-btn"></i>

              </span>
              <span onClick={handleCancelClick} className='btn p-0'>
                <i className="bi bi-x-circle text-info auction-btn"></i>
              </span>
            </div>
          ) : (
            <div className="d-flex justify-content-between">
              <span onClick={() => handleEditClick(item.id)} className='btn p-0'>
                <i className="bi bi-pencil-square text-info auction-btn"></i>
              </span>
              <span onClick={() => handledeletealert(item.id)} className='btn p-0'>
                <i className="bi bi-trash3-fill text-danger auction-btn"></i>
              </span>
            </div>
          )}
        </td>

        {title === "Org Details" && (
          <td className='text-center'>
            <a href={`unit-master/${item.client_id}`}>
              <i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i>
            </a>
          </td>
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={header.length + 5} className="text-center">No records found.</td>
    </tr>
  )}
</tbody>

                                                </table>
                                            ) : (
                                                <h1></h1>
                                            )}
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                        <Dialog
                            open={openeditalert}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle>{"Are you sure?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    Are you sure you want to edit this {title}? Any unsaved changes might be lost.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseeditalert}>No</Button>
                                <Button onClick={handleSaveClickconfirmed}>Yes</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={opendeletealert}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle>{"Are you sure?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    Are you sure you want to delete this {title}? This action cannot be undone.

                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handledeleteClosealert}>No</Button>
                                <Button onClick={handledeleteClickconfirmed}>Yes</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={opendeletemultialert}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle>{"Are you sure?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    Are you sure you want to delete those {title}? This action cannot be undone.

                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handledeletemultiClosealert}>No</Button>
                                <Button onClick={selectedDelete}>Yes</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reusabletable
